import React from "react";

const Terms = () => {
  return (
    <div className="legal-page">
      <h1>利用規約</h1>
      <p>
        本利用規約（以下「本規約」といいます。）は、本サイト（以下「当サイト」といいます。）の利用条件を定めるものです。
        ユーザーの皆さまは、本規約に同意の上で当サイトをご利用ください。
      </p>

      <h2>第1条（適用）</h2>
      <p>
        本規約は、ユーザーと当サイト運営者との間の一切の関係に適用されるものとします。
      </p>

      <h2>第2条（禁止事項）</h2>
      <ul>
        <li>法令または公序良俗に違反する行為</li>
        <li>当サイトの運営を妨害する行為</li>
        <li>他のユーザーの個人情報を不正に収集・利用する行為</li>
      </ul>

      <h2>第3条（免責事項）</h2>
      <p>
        当サイトの内容は予告なく変更される場合があります。運営者は、当サイトの利用により生じた損害について一切の責任を負いません。
      </p>
      <h2>第4条（アフィリエイトプログラムの利用）</h2>
<p>
  当サイトは、Amazonアソシエイト・プログラムなどのアフィリエイトプログラムを通じて商品・サービスを紹介しています。
  これらのリンクを経由して商品を購入した場合、当サイトは報酬を受け取る場合があります。
</p>
<p>
  商品やサービスに関するお問い合わせは、各販売者様に直接お願いいたします。
</p>


      <p>制定日：2025年10月28日</p>
    </div>
  );
};

export default Terms;

